<div class="modal-header">
  <button type="button"
          class="btn-close"
          (click)="onCloseClicked()"
          aria-label="Close">
  </button>
</div>

<div class="modal-body text-center">
  <ng-container *ngIf="status === BookVisitStatus.Unknown">
    <i-feather name="alert-circle"
               class="icon-check dvi-icon-color xl my-4"></i-feather>
    <h1 *ngIf="status === BookVisitStatus.Unknown"
        class="h4 fw-bolder"
        [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-MODAL.UNKNOWN-ERROR-TITLE'"></h1>

    <button type="button"
            class="mb-2 btn btn-link btn-block"
            (click)="tryAgain()"
            [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-MODAL.TRY-AGAIN'"></button>
  </ng-container>

  <ng-container *ngIf="status === BookVisitStatus.SlotNotAvailable">
    <i-feather name="calendar"
               class="icon-check dvi-icon-color xl my-4"></i-feather>
    <h1 class="h4 fw-bolder"
        [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-MODAL.SLOT-NOT-AVAILABLE-TITLE'"></h1>

    <button type="button"
            class="mb-2 btn btn-link btn-block"
            (click)="changeVisitSlot()"
            [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-MODAL.CHANGE-VISIT-SLOT'"></button>
  </ng-container>

  <ng-container *ngIf="status === BookVisitStatus.UsernameAlreadyInUse">
    <i-feather name="alert-circle"
               class="icon-check dvi-icon-color xl my-4"></i-feather>
    <h1 class="h5 fw-bolder mb-2"
        [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-MODAL.USERNAME-ALREADY-IN-USE'"></h1>
    <h1 class="h5 fw-bolder"
        [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-MODAL.RESET-OR-LOGIN'"></h1>

    <div class="d-flex flex-column flex-sm-row justify-content-between mt-5">
      <button type="button"
              class="btn btn-lg btn-outline-primary mb-3 mb-sm-0"
              (click)="onResetPassword()"
              [translate]="'SHARED.LINKS.PASSWORD-RESET.TEXT'"></button>
      <button type="button"
              class="btn btn-lg btn-primary"
              (click)="openSignInPopup()"
              [translate]="'SHARED.LINKS.SIGN-IN.TEXT'"></button>
    </div>
  </ng-container>

  <button *ngIf="status !== BookVisitStatus.UsernameAlreadyInUse"
          type="button"
          class="mb-2 btn btn-link btn-block"
          (click)="onCloseClicked()"
          [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-MODAL.GO-BACK'"></button>
</div>
